import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

export default function PromotionSection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const promoPoints = [
    "Hỗ trợ đốt cháy mỡ thừa",
    "Giảm mỡ toàn thân",
    "Hỗ trợ cải thiện vóc dáng",
    "Giảm đau nhức xương khớp",
    "Thư giãn cơ vai gáy cực dễ chịu",
  ];

  return (
    <section ref={sectionRef} className="w-full py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div
          className={`relative bg-primary-700 rounded-xl md:rounded-2xl overflow-hidden transition-all duration-700 ${
            visible
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 md:w-96 md:h-96 bg-accent-400 rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-48 h-48 md:w-72 md:h-72 bg-primary-400 rounded-full blur-3xl" />
          </div>

          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-10 p-6 md:p-10 lg:p-14">
            {/* Left content */}
            <div className="flex flex-col justify-center">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/20 text-accent-300 text-xs md:text-sm font-label font-medium rounded-full mb-4 w-fit">
                <i className="ri-gift-line" />
                Ưu đãi đặc biệt
              </span>
              <h2 className="font-display text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 mb-3 leading-tight">
                Trải nghiệm công nghệ cao
              </h2>
              <p className="text-sm md:text-base text-background-200 mb-6 font-body leading-relaxed">
                Chỉ với giá cực ưu đãi cho lần trải nghiệm đầu tiên. Đừng bỏ lỡ cơ hội nâng tầm sức khỏe với công nghệ hiện đại nhất!
              </p>

              {/* Price display */}
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-accent-400">
                  139K
                </span>
                <span className="text-sm md:text-base text-background-300 font-label">
                  / lần trải nghiệm đầu tiên
                </span>
              </div>

              <Link
                to="/booking"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-accent-500 hover:bg-accent-600 text-background-50 font-label text-sm md:text-base font-semibold whitespace-nowrap rounded-md transition-colors w-fit"
              >
                Đăng ký ngay
                <i className="ri-arrow-right-line" />
              </Link>
              <p className="text-xs text-background-400 mt-3 font-label">
                * Số lượng suất ưu đãi có hạn. Đăng ký ngay để nhận giá đặc biệt.
              </p>
            </div>

            {/* Right content - benefits list */}
            <div className="flex flex-col justify-center">
              <div className="bg-primary-800/50 backdrop-blur-sm rounded-lg p-5 md:p-6 border border-primary-600/30">
                <h3 className="font-display text-base md:text-lg font-semibold text-background-50 mb-4">
                  Công nghệ mới tại Xanh Wellness
                </h3>
                <ul className="space-y-3">
                  {promoPoints.map((point, index) => (
                    <li
                      key={index}
                      className="flex items-center gap-3 text-sm md:text-base text-background-200"
                    >
                      <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center rounded-full bg-accent-500/30 text-accent-400 shrink-0">
                        <i className="ri-check-line text-xs md:text-sm" />
                      </div>
                      <span className="font-body">{point}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-5 pt-4 border-t border-primary-600/30 flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-background-50/10 text-background-200">
                    <i className="ri-user-smile-line text-lg md:text-xl" />
                  </div>
                  <div>
                    <div className="font-label text-xs md:text-sm font-medium text-background-100">
                      Phù hợp mọi lứa tuổi
                    </div>
                    <div className="text-xs text-background-400 font-label">
                      Buổi công nghệ cao an toàn, hiệu quả
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}